import { Box } from '@mui/material';
import ClientsList from 'components/featured/Client/ClientsList';
import CustomAlert from 'components/shared/CustomAlert/CustomAlert';
import CustomAlertContain from 'components/shared/CustomAlert/CustomAlertContain';
import CustomButton from 'components/shared/CustomButton/CustomButton';
import CustomHeadline from 'components/shared/CustomHeadline/CustomHeadline';
import CustomTab from 'components/shared/CustomTab/CustomTab';
import { LayoutSwitcher } from 'components/shared/LayoutSwitcher';
import { ClientType } from 'model/client.model';
import { LayoutType } from 'model/deals.model';
import React, { SyntheticEvent, useEffect, useState } from 'react';
import { DashboardService } from 'service/dashboard.service';
import { HuddleClientService } from 'service/huddle-client.service';
import zeplinColor from 'theme/Color';
import ClientDrawer from './ClientForm/FormDrawer/ClientDrawer';
import LinkingForm from './ClientForm/Forms/LinkingForm';
import NewClientType from './ClientForm/TypeModal/NewClientType';

type SportsProps = {
  link: '';
  title: '';
  source: '';
};

const Client = () => {
  const new_client = sessionStorage.getItem('new-client') || '';
  const platform_created = sessionStorage.getItem('platform') || '';
  const link_successful = sessionStorage.getItem('link-successful') === 'true';

  const currentClientsLayout =
    (sessionStorage.getItem('currentClientsLayout') as LayoutType) || LayoutType.KANBAN;
  const [layout, setLayout] = useState<LayoutType>(currentClientsLayout);

  const handleLayoutChange = (_: SyntheticEvent, newValue: LayoutType) => {
    sessionStorage.setItem('currentClientsLayout', newValue);
    setLayout(newValue);
  };

  const [alert, setAlert] = React.useState('');
  const [value, setValue] = React.useState(0);
  const [anchorEl, setAnchorEl] = React.useState<HTMLDivElement | null>(null);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [drawerState, setDrawerState] = React.useState(false);
  const [typeSelected, setTypeSelected] = useState('Talent');

  const [linkModal, setLinkModal] = useState(false);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const [data, setData] = useState<any>({
    clients: [
      {
        Name: '',
        AccountId: '',
        closedDealAmount: null,
        openDealAmount: null,
        category: null,
      },
    ],
  });

  const [loading, setLoading] = useState(false);
  const getAllClient = async () => {
    setLoading(true);
    try {
      const response = await HuddleClientService.getAllClient();
      setData({
        clients: response.clients.sort((a: ClientType, b: ClientType) =>
          a?.Name.localeCompare(b?.Name),
        ),
      });
    } catch (err: any) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleNewClientLink = () => {
    setAlert('');
    setLinkModal(true);
  };

  useEffect(() => {
    getAllClient();
  }, []);

  const ClientTabs = [
    {
      label: 'All',
      id: 1,
      isHidden: value !== 0,
      Component: (
        <Box>
          <ClientsList layout={layout} category={'all'} loading={loading} data={data} />
        </Box>
      ),
    },
    {
      label: 'Talent',
      id: 2,
      isHidden: value !== 1,
      Component: (
        <Box>
          <ClientsList layout={layout} category={'Talent'} loading={loading} data={data} />
        </Box>
      ),
    },
    {
      label: 'Athlete',
      id: 3,
      isHidden: value !== 2,
      Component: (
        <Box>
          <ClientsList layout={layout} category={'Athlete'} loading={loading} data={data} />
        </Box>
      ),
    },
    {
      label: 'Business Development',
      id: 4,
      isHidden: value !== 3,
      Component: (
        <Box>
          <ClientsList
            layout={layout}
            category={'Business_Development'}
            loading={loading}
            data={data}
          />
        </Box>
      ),
    },
  ];

  const [sportsData, setSportsData] = React.useState<SportsProps[]>([
    {
      link: '',
      title: '',
      source: '',
    },
  ]);

  const getSportNews = async () => {
    try {
      const res: { latestNews: SportsProps[] } = await DashboardService.getSportNews();
      console.log(res);
      setSportsData(res?.latestNews);
    } catch (err) {
      console.log(err, 'err');
    }
  };

  const handleTaskCreateClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setModalOpen(true);
  };
  const handleModalClose = (next = false) => {
    setModalOpen(false);
    sessionStorage.removeItem('sf_redirect');
    sessionStorage.removeItem('sf_edit');
    sessionStorage.removeItem('sf_delete');
    sessionStorage.removeItem('sf_path');
  };
  const handleContinueAdd = () => {
    handleModalClose(true);
    setDrawerState(true);
  };

  useEffect(() => {
    getSportNews();
    new_client && setAlert('Client added');
    new_client && setTimeout(handleNewClientLink, 1000);
    link_successful && setAlert('Integrations connected');
    link_successful &&
      setTimeout(() => {
        setAlert('');
        sessionStorage.removeItem('link-successful');
      }, 2000);
  }, [new_client]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <Box>
        <CustomHeadline sportsData={sportsData} />
      </Box>
      <Box
        sx={{
          padding: '24px 1.5rem 0rem 1.5rem',
          position: 'relative',
          overflow: 'auto',
        }}
      >
        {' '}
        <CustomTab tabs={ClientTabs} handleChange={handleChange} value={value} />
        <Box
          sx={{
            position: 'absolute',
            top: '1.5rem',
            right: '1.5rem',
            display: 'flex',
            gap: '16px',
          }}
        >
          <LayoutSwitcher layout={layout} onLayoutChange={handleLayoutChange} />

          <CustomButton
            disabled={false}
            onClick={handleTaskCreateClick}
            variant='contained'
            color={'primary'}
            buttonVariant='responsiveButtonLarge'
            style={{
              width: '100%',
              borderRadius: { xs: '10px', xl: '14px' },
              height: { xl: 48 },
              padding: { xs: '10px 12px', xl: '14px 16px' },
              '&.Mui-focusVisible': { backgroundColor: '#333CAA' },
            }}
            textStyle={{ color: zeplinColor.Neutral1 }}
            text={'New Client'}
          />
        </Box>
      </Box>

      {modalOpen && (
        <NewClientType
          handleModalClose={handleModalClose}
          modalOpen={modalOpen}
          handleContinueAdd={handleContinueAdd}
          setTypeSelected={setTypeSelected}
          typeSelected={typeSelected}
          setAnchorEl={setAnchorEl}
          sf_token={''}
        />
      )}

      {drawerState && (
        <ClientDrawer
          drawerState={drawerState}
          typeSelected={typeSelected}
          setDrawerState={setDrawerState}
          getAllClient={getAllClient}
        />
      )}

      <LinkingForm
        modalOpen={linkModal}
        clientId={new_client}
        platform_created={platform_created}
        setLinkModal={setLinkModal}
        getAllClient={getAllClient}
      />

      <CustomAlert
        open={alert ? true : false}
        handleClose={() => {
          setAlert('');
        }}
        message={
          <CustomAlertContain
            alertIcon={
              <img src='/assets/checkmark-green.png' width={24} height={24} alt='green checkmark' />
            }
            alert={alert ? `${alert}` : ''}
          />
        }
        error={false}
      />
    </Box>
  );
};

export default Client;
